'use strict';

var base = require('client_core/cart/cart');

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
  $('.number-of-items').empty().append(data.numItems == 1 ? data.resources.numberOfItem : data.resources.numberOfItems);
  $('.shipping-cost span').empty().append(data.totals.totalShippingCost);
  $('.tax-total span').empty().append(data.totals.totalTax);
  $('.grand-total-sum').empty().append(data.totals.grandTotalLessGiftCertificatePaymentInstrumentsFormatted);
  $('.sub-total').empty().append(data.totals.subTotal);
  $('.minicart-quantity').empty().append(data.numItems);
  $('.minicart-footer .btn-num-items').text(data.numItems);
  $('.minicart-link').attr({
    'aria-label': data.resources.minicartCountOfItems,
    title: data.resources.minicartCountOfItems
  });

  // Update cart title with quantity
  $('sup, cart-number-of-items').text(data.pageTitle);

  // Show empty cart
  if (data.numItems === 0) {
    $('.cart-page').addClass('empty');
    $('.empty-cart-content').css('display', '');
    $('.cart-items-header').hide();
    $('.cart-content').hide();
    $('.empty-cart-container').hide();
    $('.order-totals-card').hide();
    $('.promo-code-card').hide();
    $('.checkout-continue').hide();
    $('.totals-card').hide();
  }
  $('.shipping-total-cost span').text(data.totals.totalShippingCost);
  if (data.totals.orderLevelDiscountTotal.value > 0) {
    $('.order-discount').removeClass('hide-order-discount');
    $('.order-discount-total').empty().append('- ' + data.totals.orderLevelDiscountTotal.formatted);
  } else {
    $('.order-discount').addClass('hide-order-discount');
  }

  // totalSavings is added by redkap_client_core/cartridge/models/totals.js. Without this
  // the row keeps its server-rendered value until the next full page load.
  if (data.totals.totalSavings && data.totals.totalSavings.value > 0) {
    $('.total-savings').removeClass('hide-total-savings');
    $('.total-savings-amount span').empty().append('- ' + data.totals.totalSavings.formatted);
  } else {
    $('.total-savings').addClass('hide-total-savings');
  }
  if (data.totals.shippingLevelDiscountTotal.value > 0 && !data.totals.hasFreeShipping) {
    $('.shipping-discount').removeClass('hide-shipping-discount');
    $('.shipping-discount-total span').empty().append('- ' + data.totals.shippingLevelDiscountTotal.formatted);
  } else {
    $('.shipping-discount').addClass('hide-shipping-discount');
  }
  if (data.payment.giftCertificatePaymentInstruments.length) {
    $('.giftcertificate-discount').removeClass('d-none');
    $('.giftcertificate-discount-label').text(data.totals.giftCertificatePaymentInstrumentsLabel);
    $('.giftcertificate-discount-total').text('- ' + data.totals.giftCertificatePaymentInstrumentsTotalFormatted);
  } else {
    $('.giftcertificate-discount').addClass('d-none');
  }
  if (data.totals.grandTotalLessGiftCertificatePaymentInstrumentsValue) {
    $('.cartAdditionalPaymentButtons').removeClass('d-none');
  } else {
    $('.cartAdditionalPaymentButtons').addClass('d-none');
  }
  data.items.forEach(function (item) {
    if (data.totals.orderLevelDiscountTotal.value > 0) {
      $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
    }
    if (item.renderedPromotions) {
      $('.item-' + item.UUID).empty().append(item.renderedPromotions);
    } else {
      $('.item-' + item.UUID).empty();
    }
    if (item.customizer && item.customizer.isCustomized) {
      var $item = $('.cart-product-card[data-uuid="' + item.UUID + '"]');
      item.customizer.addonProducts.forEach(function (addonItem) {
        if (addonItem) {
          var addonItemHTML = '';
          var $addonContainer = $('[data-customizer-addon-product-uuid="' + addonItem.uuid + '"] .addon-product-price-container');
          if (addonItem.hasDiscount) {
            $addonContainer.addClass('text-nowrap');
            addonItemHTML = "<span class=\"addon-product-price strike-through\">+".concat(addonItem.price.formatted, "</span>\n                                         <span class=\"addon-product-sales-price\">+").concat(addonItem.salesPrice.formatted, "</span>");
          } else {
            $addonContainer.removeClass('text-nowrap');
            addonItemHTML = "<span class=\"addon-product-price\">+".concat(addonItem.salesPrice.formatted, "</span>");
          }
          $addonContainer.html(addonItemHTML);
        }
      });
      $('.item-total-' + item.UUID + ' .line-item-total-price-amount').text(item.customizer.priceWithCustomizations.adjusted.formatted);
      if (item.customizer.approachingCustomizationDiscounts && item.customizer.approachingCustomizationDiscounts.length) {
        $item.find('.line-item-approaching-discounts').show();
        var approachingDiscountsHtml = '';
        item.customizer.approachingCustomizationDiscounts.forEach(function (discount) {
          var $tooltip = $('<span class="tooltip-whats-this text-nowrap" data-html="true" data-toggle="tooltip"></span></div>').text(discount.tooltipLink).attr('title', '<div class="text-left">' + discount.tooltipBody + '</div>');
          var tooltipHtml = $('<div>').append($tooltip).html();
          tooltipHtml = '<div class="text-right ml-2">' + tooltipHtml + '</div>';
          approachingDiscountsHtml = approachingDiscountsHtml + '<div class="custom-approaching-discount warning-text d-flex flex-column flex-lg-row justify-content-between"><span>' + discount.discountMsg + '</span>' + tooltipHtml + '</div>';
        });
        $item.find('.line-item-approaching-discounts .col-12').html(approachingDiscountsHtml);
        $('body').trigger('tooltip:init');
      } else {
        $item.find('.line-item-approaching-discounts').hide();
      }
    } else {
      $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
      $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
      $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
    }
  });
  if (data.totals.klarnaTotal) {
    $('klarna-placement').attr('data-purchase-amount', data.totals.klarnaTotal);
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
    window.KlarnaOnsiteService.push({
      eventName: 'refresh-placements'
    });
  }
}
base.updateCartTotals = updateCartTotals;

/**
 * Copied from workwear_client_core cartridge to skip error message if it's unavailable msg.
 * Updated from base to prevent removing the `.cart` html when the basket is empty
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
  if (data.valid.error && !data.valid.hasUnavailableProduct) {
    if (data.valid.message) {
      var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' + 'fade show" role="alert">' + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' + '<span aria-hidden="true">&times;</span>' + '</button>' + data.valid.message + '</div>';
      $('.cart-error').append(errorHtml);
    } else {
      $('.valid-cart-error .close').trigger('click');
    }
    $('.checkout-btn').addClass('disabled');
  } else {
    $('.checkout-btn').removeClass('disabled');
    $('.valid-cart-error .close').trigger('click');
  }
}
base.validateBasket = validateBasket;

/**
 * Markup for one approaching discount row, matching
 * redkap_client_core/cartridge/templates/default/cart/cartApproachingDiscount.isml.
 *
 * @param {Object} discount - approaching discount from the cart model
 * @param {string} progressLabel - accessible name for the progress bar
 * @returns {string} row markup
 */
function approachingDiscountHtml(discount, progressLabel, bonusProgressLabel) {
  var isBonusProduct = discount.isBonusProduct === true;
  var html = '<div class="single-approaching-discount' + (isBonusProduct ? ' is-bonus-product' : '') + '"><div class="approaching-discount-content">' + '<div class="approaching-discount-msg">' + discount.discountMsg + '</div>';

  // percentComplete is only present for amount-based promotions.
  if (discount.percentComplete !== null && discount.percentComplete !== undefined) {
    html += '<div class="approaching-discount-progress" role="progressbar"' + ' aria-valuenow="' + discount.percentComplete + '"' + ' aria-valuemin="0" aria-valuemax="100"' + ' aria-label="' + (isBonusProduct ? bonusProgressLabel : progressLabel) + '">' + '<div class="approaching-discount-progress-bar" style="width: 0%" data-progress="' + discount.percentComplete + '">' + '<span class="approaching-discount-marker ' + (isBonusProduct ? 'approaching-discount-bonus' : 'approaching-discount-truck') + '" aria-hidden="true"></span>' + '</div></div>';
  }
  return html + '</div></div>';
}

/**
 * Grows progress bars from 0% to their target on the next frames, so a freshly rendered bar
 * animates into place instead of appearing already filled.
 *
 * @param {jQuery} $scope - element containing [data-progress] bars
 */
function animateProgressBars($scope) {
  var $bars = $scope.find('[data-progress]');
  if (!$bars.length) {
    return;
  }
  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(function () {
      $bars.each(function () {
        $(this).css('width', $(this).attr('data-progress') + '%');
      });
    });
  });
}

/**
 * Markup for one compact bonus bar in the mini cart.
 * @param {Object} discount - approaching discount with progress values
 * @param {string} label - progress bar aria label
 * @returns {string} bar markup
 */
function miniCartBonusBarHtml(discount, label) {
  var html = '<div class="minicart-approaching-bonus">' + '<span class="minicart-approaching-bonus-icon" aria-hidden="true"></span>' + '<div class="minicart-approaching-bonus-content">' + '<div class="minicart-approaching-bonus-msg">' + discount.discountMsg + '</div>';
  if (discount.percentComplete !== null && discount.percentComplete !== undefined) {
    html += '<div class="minicart-approaching-bonus-progress" role="progressbar"' + ' aria-valuenow="' + discount.percentComplete + '" aria-valuemin="0" aria-valuemax="100"' + ' aria-label="' + label + '">' + '<div class="minicart-approaching-bonus-progress-bar" style="width: 0%" data-progress="' + discount.percentComplete + '"></div>' + '</div>';
  }
  return html + '</div></div>';
}

/**
 * Keeps the mini cart's bonus bars in step with the basket after quantity changes made from
 * the mini cart itself, which do not re-fetch its markup.
 * @param {Array} discounts - updated approaching discounts
 */
function updateMiniCartBonusBars(discounts) {
  var $cart = $('.minicart .popover .cart');
  if (!$cart.length) {
    return;
  }
  var bonus = discounts.filter(function (discount) {
    return discount.isBonusProduct === true;
  });
  var $existing = $cart.find('.minicart-approaching-bonus');
  if (bonus.length && bonus.length === $existing.length) {
    bonus.forEach(function (discount, index) {
      var $row = $existing.eq(index);
      $row.find('.minicart-approaching-bonus-msg').html(discount.discountMsg);
      $row.find('.minicart-approaching-bonus-progress').attr('aria-valuenow', discount.percentComplete);
      $row.find('.minicart-approaching-bonus-progress-bar').attr('data-progress', discount.percentComplete).css('width', discount.percentComplete + '%');
    });
    return;
  }
  $existing.remove();
  var label = $cart.data('bonus-progress-label') || '';
  $cart.find('.product-summary').before(bonus.map(function (discount) {
    return miniCartBonusBarHtml(discount, label);
  }).join(''));
  animateProgressBars($cart);
}

/**
 * Re-renders the approaching discount msgs, keeping the progress bar.
 *
 * Updates discount messages and progress bars in-place to enable smooth bar transitions after cart changes.
 *
 * @param {Array} approachingDiscounts - updated approaching discounts for the cart
 */
/**
 * Swaps the mini cart's order-level bonus block (chosen products or the callout) when a quantity
 * change crosses the promotion threshold while the mini cart is open.
 * @param {Object} data - quantity change response
 */
function updateMiniCartOrderBonus(data) {
  var $block = $('.minicart .popover .minicart-order-bonus');
  if ($block.length && typeof data.miniCartOrderBonusHtml === 'string') {
    $block.html(data.miniCartOrderBonusHtml);
  }
}
function updateApproachingDiscounts(approachingDiscounts) {
  var discounts = approachingDiscounts || [];
  updateMiniCartBonusBars(discounts);
  var $container = $('.approaching-discounts');
  if (!$container.length) {
    return;
  }
  $container.toggleClass('is-empty', discounts.length === 0);
  var progressLabel = $container.data('progress-label') || '';
  var bonusProgressLabel = $container.data('bonus-progress-label') || '';
  var $rows = $container.find('.single-approaching-discount');

  // Only update changed values if list shape matches to preserve progress bar animation.
  var sameShape = discounts.length > 0 && discounts.length === $rows.length && discounts.every(function (discount, index) {
    var $row = $rows.eq(index);
    var hasBar = $row.find('.approaching-discount-progress-bar').length > 0;
    var wantsBar = discount.percentComplete !== null && discount.percentComplete !== undefined;
    var sameKind = $row.hasClass('is-bonus-product') === (discount.isBonusProduct === true);
    return hasBar === wantsBar && sameKind;
  });
  if (sameShape) {
    discounts.forEach(function (discount, index) {
      var $row = $rows.eq(index);
      $row.find('.approaching-discount-msg').html(discount.discountMsg);
      if (discount.percentComplete !== null && discount.percentComplete !== undefined) {
        $row.find('.approaching-discount-progress').attr('aria-valuenow', discount.percentComplete);
        $row.find('.approaching-discount-progress-bar').attr('data-progress', discount.percentComplete).css('width', discount.percentComplete + '%');
      }
    });
    return;
  }
  var html = '';
  discounts.forEach(function (discount) {
    html += approachingDiscountHtml(discount, progressLabel, bonusProgressLabel);
  });
  $container.empty().append(html);
  animateProgressBars($container);
}
base.updateApproachingDiscounts = updateApproachingDiscounts;
base.updateMiniCartOrderBonus = updateMiniCartOrderBonus;
var baseInit = base.init;
var toastHelpers = require('core/components/toast');

/**
 * Confirms an applied promo code with a toast. The base handler reports failures inline but
 * gives no signal on success beyond clearing the field.
 *
 * Removing a coupon fires the same promotion:success event as applying one, so the event
 * alone cannot tell them apart. The flag is set when the promo form is submitted and read
 * back when the request resolves, so only an apply shows the toast.
 */
function initPromoCodeFeedback() {
  var applyInProgress = false;

  // Bound after the base submit handler, which preventDefaults but does not stop
  // propagation, so this still runs on every apply attempt. An empty field is skipped
  // because the base handler returns before making a request, which would otherwise
  // leave the flag set and toast on the next coupon removal.
  $('body').on('submit', '.promo-code-form', function () {
    applyInProgress = !!$('.coupon-code-field').val();
  });
  $('body').on('promotion:error', function () {
    applyInProgress = false;
  });
  $('body').on('promotion:success', function () {
    if (!applyInProgress) {
      return;
    }
    applyInProgress = false;
    var text = $('.promo-code-form').data('success-message');
    if (text) {
      toastHelpers.methods.show('success', text, false);
    }
  });
}
base.init = function () {
  baseInit.call(this);
  initPromoCodeFeedback();
  animateProgressBars($('.approaching-discounts'));
  $('body').on('minicart:loaded', function () {
    animateProgressBars($('.minicart .popover'));
  });
};
module.exports = base;